import { useEffect, useState } from 'react';
import { usePageAnalytics } from '@/hooks/usePageAnalytics';

// Inner component only mounts (and its hooks only run) after the browser is idle.
// This keeps Supabase analytics calls from competing with first paint / hydration.
function PageAnalyticsInner() {
  usePageAnalytics();
  return null;
}

export function PageAnalyticsTracker() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const start = () => { if (!cancelled) setReady(true); };

    if ('requestIdleCallback' in window) {
      const id = (window as any).requestIdleCallback(start, { timeout: 4000 });
      return () => { cancelled = true; (window as any).cancelIdleCallback?.(id); };
    }
    const t = setTimeout(start, 2500);
    return () => { cancelled = true; clearTimeout(t); };
  }, []);

  if (!ready) return null;
  return <PageAnalyticsInner />;
}
